export default "__VITE_ASSET__BjWNc__h__"